import close from "../../../assets/icons/close.svg"

const CampaignUpdates = ({onClose, updates}) => {
    return ( 
        <div className="fixed top-0 w-full h-screen bg-black/80 flex justify-center items-center px-4 z-50">
            <div className="bg-white max-h-[80%] md:max-h-[90%] overflow-y-auto w-full md:w-1/2 rounded">
                <div className="sticky top-0 bg-white flex justify-between items-center border-b px-6 md:px-10 py-6">
                  <p className="font-medium">Campaign updates:</p>
                  <span className="cursor-pointer" onClick={onClose}><img src={close} alt="" className="h-5"/></span>
                </div>
                <div className="grid gap-4 px-6 md:px-10 py-5">
                  {updates.map((update, index) => (
                    <div key={index} className="pb-4 last:pb-0 border-b last:border-0">
                      <p className="text-sm text-secondary">{update.time_in}</p>
                      <p>{update.comment}</p>
                    </div>
                  ))}
                </div>
            </div>
        </div>
     );
}
 
export default CampaignUpdates;